/**
 * @name          swiperSlider
 * @version       0.1
 * @lastmodified  2019-04-03
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        re-lounge
 *
 * based on: http://jqueryboilerplate.com/
 */

/* globals Swiper */

(function($, window, document, undefined) {
  'use strict';

  var pluginName = 'swiperSlider',
    defaults = {
      contentSelector: '.slider__content',
      loadingClass: 'slider--loading',
      breakpoint: '1023',
      autoplayDelay: 3000,
      maxItemsForDots: 6,
      defaultConfig: {
        init: true,
        on: {},
        pagination: {
          el: '.swiper-pagination',

          clickable: true,
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: false,
        loop: true,
        autoHeight: true,
        threshold: 70,
        followFinger: false,
        hashNavigation: false,
        allowTouchMove: true,
      },
    };

  function Plugin(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, defaults, options);
    this.$sliderContent = this.$element.find(this.options.contentSelector);
    this.$pagination = this.$element.find('.swiper-pagination');
    this.paginationHeight = this.$pagination.height();
    this.itemCount = this.$sliderContent.children().length;
    this.slider = null;

    if (this.itemCount === 1) {
      // If there is only one slide
      this.$element.find('.picture--slider').responsiveImage({
        attributes: ['loading', 'title', 'alt', 'class', 'width', 'height'],
        onGetWidth: function() {
          return $(window)[0].innerWidth;
        },
      });

      this.$element.removeClass(this.options.loadingClass);
      return;
    }

    if (this.$element.closest('.tabs').length) {
      // If it`s not the first tab
      if (this.$element.closest('.tabs-content').index() > 1) {
        this.options.defaultConfig.init = false;
      }
    }

    this.init();
  }

  var methods = {
    init: function() {
      var self = this;

      var config = self.options.defaultConfig;

      config.on.init = $.proxy(self.onSliderInit, self);

      config.on.resize = $.proxy(self.onSliderResizeAfter, self);
      config.on.slideChangeTransitionEnd = $.proxy(self.onSlideAfter, self);

      // configure autoplay mode
      self.isAutoModeActive = false;
      self.autoSlideInterval = self.options.autoplayDelay;

      function isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
      }

      if (isNumeric(self.$element.data('auto-slide'))) {
        console.log('true');
        self.autoSlideInterval = parseInt(self.$element.data('auto-slide'));
      }

      // configure recalculate arrows
      self.recalculateArrows = false;
      if (self.$element.data('recalculate-arrows')) {
        self.recalculateArrows = true;
      }

      // reconfigure pagination type
      if (self.itemCount > self.options.maxItemsForDots) {
        config.pagination.type = 'fraction';
      }

      if (!isNaN(self.autoSlideInterval) && self.autoSlideInterval > 0) {
        config.autoplay = {
          delay: self.autoSlideInterval,
        };

        self.$element.on('mouseenter.slider', function() {
          self.slider.autoplay.stop();
        });
        self.$element.on('mouseleave.slider', function() {
          self.slider.autoplay.start();
        });
      }

      self.slider = new Swiper(self.$element.get(0), config);
    },

    onSliderInit: function() {
      var self = this;

      // init responsive image plugin
      self.$element.find('.picture--slider').responsiveImage({
        attributes: ['loading', 'title', 'alt', 'class', 'width', 'height'],
        onGetWidth: function() {
          return $(window)[0].innerWidth;
        },
      });

      self.$element.on('objectfit.ready', 'img', function() {
        if (self.slider) {
          // safeguard for IE 11
          self.slider.update();
          self.setArrows();
        }
      });

      self.$element
        .find('.picture')
        .on('load.source.responsiveImage', function() {
          if (self.slider) {
            // safeguard for IE 11
            self.slider.update();
            self.setArrows();
          }
        });

      self.$element.removeClass(self.options.loadingClass);

      // propagate click on whole item to layer button
      self.$element
        .parent()
        .not('.stage--narrow')
        .not('.stage--loginKomex')
        .find('.stage__item')
        .each(function() {
          // only do that if there is only one button or link in stage
          if ($(this).find('.button, a').length >= 1) {
            $(this).on('click', function(e) {
              if ($(e.target).hasClass('icon-bar__link-icon')) {
                return true;
              }
              // trigger button click when clicked element is not the button
              if (
                e.target.tagName !== 'A' &&
                !$(e.target).hasClass('.button')
              ) {
                e.preventDefault();
                $(this)
                  .find('.button, a')
                  .first()[0]
                  .trigger('click');
              }
            });
          } else {
            $(this).addClass('stage__item--normalcursor');
          }
        });

      if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
        $('.stage__image img').objectFit();
      }

      self.setArrows();
    },

    onSliderResizeAfter: function() {
      this.setArrows();
      if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
        $('.stage__image img').objectFit();
      }
    },

    onSlideAfter: function() {
      this.$element.trigger('slideChangeTransitionEnd');
    },

    setArrows: function() {
      var self = this;
      var buildArrows = function(imageHeight) {
        var $prev = self.$element.find('.swiper-button-prev');
        var $next = self.$element.find('.swiper-button-next');

        $prev.removeAttr('style').addClass('icon-chevron-left');
        $next.removeAttr('style').addClass('icon-chevron-right');

        var top = imageHeight
          ? imageHeight / 2 - $prev.height() / 2
          : self.$element.height() / 2 - $prev.height() / 2;

        $prev.css('top', top);
        $next.css('top', top);
      };

      var setPaginationPositon = function(imageHeight) {
        var positionTuning = $(window)[0].innerWidth >= 1024 ? 23 : 13;

        var top =
          (imageHeight || self.$element.height()) -
          self.paginationHeight -
          positionTuning;

        self.$pagination.css('top', top);
      };

      var instance = self.$element[0].swiper;
      var activeSliderElement = instance.slides[instance.activeIndex];
      var sliderImage = $(activeSliderElement).find('figure');
      self.imageHeight = null;

      if (sliderImage.length > 0) {
        self.imageHeight = sliderImage.height();

        if (!self.imageHeight) {
          sliderImage.on('load', function() {
            buildArrows(self.imageHeight);
            setPaginationPositon(self.imageHeight);
          });
        } else {
          buildArrows(self.imageHeight);
          setPaginationPositon(self.imageHeight);
        }
      } else {
        buildArrows();
        setPaginationPositon();
      }

      if (self.recalculateArrows) {
        self.$element.on('slideChangeTransitionEnd', function() {
          if (self.imageHeight === 0) {
            sliderImage.load(function() {
              self.imageHeight = sliderImage.height();
              buildArrows(self.imageHeight);
              setPaginationPositon(self.imageHeight);
            });
          } else {
            buildArrows(self.imageHeight);
            setPaginationPositon(self.imageHeight);
          }
        });
      }
    },

    destroy: function() {
      this.slider.destroy();
    },
  };

  $.extend(Plugin.prototype, methods);

  $.fn[pluginName] = function(options) {
    this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));

        // trigger ready event on element
        $.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
      }
    });

    // trigger ready event globally
    if (this.length > 0) {
      $.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
    }

    return this;
  };
})(jQuery, window, document);
